
export const useFormat = () => {

    const formatDate = (date) => {
        var d = new Date(date),
            month = "" + (d.getMonth() + 1),
            day = "" + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2) month = "0" + month;
        if (day.length < 2) day = "0" + day;

        return [year, month, day].join("-");
    }

    /* Format date */
    const formatDate2 = (date) => {
        const dateFormatted = new Date(date);
        const day = dateFormatted.getDate();
        const month = dateFormatted.getMonth() + 1;
        const year = dateFormatted.getFullYear();
        return `${day}/${month}/${year}`;
    }

        /* Format date */
        const formatDateHour = (date) => {
            const dateFormatted = new Date(date);
            const day = dateFormatted.getDate();
            const month = dateFormatted.getMonth() + 1;
            const year = dateFormatted.getFullYear();
            return `${day}/${month}/${year} ${dateFormatted.toLocaleTimeString('en-US')}`;
        }

    function getBase64(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                let encoded = reader.result.toString().replace(/^data:(.*,)?/, "");
                if (encoded.length % 4 > 0) {
                    encoded += "=".repeat(4 - (encoded.length % 4));
                }
                resolve("data:image/png;base64," + encoded);
            };
            reader.onerror = (error) => reject(error);
        });
    }

    function checkPassword(str) {
        //  min 6 a 15 letras, con al menos un símbolo, letras mayúsculas y minúsculas y un número
        var re =
            /^(?=.*\d)(?=.*[!@#$%^&*.=_\-()+<>:;°|¿?])(?=.*[a-z])(?=.*[A-Z]).{6,50}$/;
        return re.test(str);
    }

    function codeCountryToOnlyCountry(val) {
        let _val = val.substr(-10);
        _val = val.replace(_val, "").replace("+", "");
        switch (_val) {
            case "52":
                return "mx";
            case "57":
                return "co";
            case "1":
                return "us";
            default:
                return "";
        }
    }


    function ImageExist(url) { var img = new Image(); img.src = url; return (img.height != 0) }

    return { formatDate, formatDate2, getBase64, checkPassword, ImageExist, codeCountryToOnlyCountry,formatDateHour }

}




